var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCalendarAddFill = function SvgCalendarAddFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 19h-2a.97.97 0 0 1-.713-.288A.97.97 0 0 1 14 18q0-.424.287-.712A.97.97 0 0 1 15 17h2v-2q0-.424.288-.713A.97.97 0 0 1 18 14q.424 0 .712.287.288.288.288.713v2h2q.424 0 .712.288.288.287.288.712 0 .424-.288.712A.97.97 0 0 1 21 19h-2v2q0 .424-.288.712A.97.97 0 0 1 18 22a.97.97 0 0 1-.712-.288A.97.97 0 0 1 17 21zM5 20q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 18V6q0-.824.587-1.412A1.93 1.93 0 0 1 5 4h1V3q0-.424.287-.712A.97.97 0 0 1 7 2q.424 0 .713.288Q8 2.575 8 3v1h6V3q0-.424.287-.712A.97.97 0 0 1 15 2q.424 0 .713.288Q16 2.575 16 3v1h1q.824 0 1.413.588Q19 5.175 19 6v6.1a6.7 6.7 0 0 0-2 0V10H5v8h7q0 .5.075 1t.275 1z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarAddFill);
export { ForwardRef as ReactComponent };